<template>
    <v-form class="mt-3" ref="recoverySmsForm" lazy-validation>
        <v-text-field
            label="Номер телефона"
            mask="phone"
            prefix="+7"
            placeholder="(000) 000 - 0000"
            v-model="recoverySms"
            v-on:input="clearServerError"
            v-on:keyup.enter="validate"
            v-bind:rules="[rules.required]"
            validate-on-blur
            v-bind:error-messages="this.$store.state.serverError"
            color="indigo_6"
            outline
            required
        ></v-text-field>

        <!-- form button -->
        <div class="layout column align-center">
            <v-btn
                class="btn text-capitalize mb-2"
                color="indigo_5"
                large
                dark
                v-on:click="validate"
                >Запросить</v-btn
            >
        </div>
    </v-form>
</template>

<script>
export default {
    name: 'recoveryFormSms',

    data: () => ({
        recoverySms: null,

        rules: {
            required: (value) => !!value || 'Это обязательное поле',
        },
    }),

    methods: {
        validate() {
            if (this.$refs.recoverySmsForm.validate()) {
                this.$store.dispatch(
                    'recoveryPassword',
                    '7' + this.recoverySms
                );
            }
        },

        clearServerError() {
            this.$store.dispatch('clearServerError');
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/style/global.scss';
</style>
